/* eslint-disable camelcase */
import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import _ from 'lodash';
import appConfig from 'app-config';
import { useTranslator } from '@jutro/locale';

import styles from './WizardPageHeader.module.scss';

import messages from './WizardPageHeader.messages';
import { Link } from '@jutro/router';

const QUOTE_TRANSACTION = [
    'CommercialProperty',
    'WC7WorkersComp',
    'Homeowners',
    'BusinessOwners',
    'PersonalAuto',
    'HOPHomeowners'
];

const WizardPageHeader = (props) => {
    const translator = useTranslator();
    const [wizardHeaderTemplate, setWizardHeaderTemplate] = useState('');
    const [routePath, setRoutePath] = useState('');
    const [accountName, setAccountName] = useState('');
    const [lobWithQuoteNumber, setLobWithQuoteNumber] = useState('');
    const {
        wizardSubmission, isSideHeader, lobFlow, displayWizardHeader, policyChangePageHeaderML
    } = props;

    useEffect(() => {
        const productCode = _.get(wizardSubmission.value, 'baseData.productCode');
        const jobType = _.get(wizardSubmission.value, 'baseData.jobType');
        const lob = (jobType === 'Renewal' && `${productCode}${jobType}`)
            || (jobType === 'PolicyChange' && `${productCode}${jobType}`)
            || productCode;
        const accountNumber = _.get(wizardSubmission.value, 'baseData.accountNumber');
        const getFirstName = _.get(wizardSubmission.value, 'baseData.accountHolder.firstName') || '';
        const getLastName = _.get(wizardSubmission.value, 'baseData.accountHolder.lastName') || '';
        const getDisplayName = _.get(wizardSubmission.value, 'baseData.accountHolder.displayName');
        const getAccountDisplayName = !getDisplayName
            ? `${getFirstName} ${getLastName}`
            : getDisplayName;
        const getAccountName = _.trim(getAccountDisplayName)
            || _.get(wizardSubmission.value, 'baseData.accountHolder.contactName')
            || _.get(wizardSubmission.value, 'baseData.accountName');

        if (lob && QUOTE_TRANSACTION.includes(productCode)) {
            setWizardHeaderTemplate('transaction');
        }
        /* eslint no-underscore-dangle: 0 */
        if (wizardSubmission._dtoName.indexOf('fnol') !== -1) {
            setWizardHeaderTemplate('claim');
        }
        
        // ML changes
        if (jobType === 'PolicyChange') {
            setWizardHeaderTemplate('policychange_ml');
        }


        setRoutePath(`/accounts/${accountNumber}/summary`);
        setAccountName(getAccountName);
        setLobWithQuoteNumber(
            translator(messages[_.camelCase(lob)], {
                quoteNumber:
                    _.get(wizardSubmission.value, 'quoteID')
                    || _.get(wizardSubmission.value, 'policyNumber'),
                jobId: _.get(wizardSubmission.value, 'jobID') || ''
            })
        );
    }, [lobFlow, translator, wizardSubmission]);

    const titleContainerClass = cx({
        [styles.gwWizardPageTitle]: !isSideHeader,
        [styles.gwWizardSidePageTitle]: isSideHeader
    });

    const categoryContainerClass = cx({
        [styles.gwWizardPageCategory]: !isSideHeader,
        [styles.gwWizardSidePageCategory]: isSideHeader
    });

    const associatedPageClass = cx({
        [styles.gwWizardPageAssociated]: !isSideHeader,
        [styles.gwWizardSidePageAssociated]: isSideHeader
    });

    const titleSeparator = isSideHeader && (
        <div className={styles.gwWizardSidePageTitleSeparator} />
    );

    const submissionQuote = wizardHeaderTemplate === 'transaction' && (
        <div className={titleContainerClass}>
            <div className={categoryContainerClass}>
                {translator(messages.accountTitle)}
                <Link className={associatedPageClass} to={routePath}>
                    {accountName}
                </Link>
            </div>
            {titleSeparator}
            {displayWizardHeader ? (
                <h1 className={cx(styles.wizardPageHeader, { [styles.gwWizardSidepageTitle]: isSideHeader })}>
                    {lobWithQuoteNumber}
                </h1>
            ) : (
                ''
            )}
        </div>
    );

    const claimHeader = useCallback(() => {
        /*
        const claimNumber = _.get(wizardSubmission.value, 'claimNumber', '');
        return wizardHeaderTemplate === 'claim' ? (
            <h1 className={styles.gwPageTitle}>
                {translator(messages.fnolNewClaim)}
                <span className={styles.gwClaimsWizardSpanNumber}>{claimNumber}</span>
            </h1>
        ) : null;
        */
    }, []);

    const policyChangeHeader_ML = useCallback(() => {
        const isGPA = appConfig.portalCode === 'GPA';
        const headerClass = isGPA ? 'ml-main-header short' : 'vertical-spacing-10';
        const h1Class = isGPA ? 'page-header' : 'page-header';
        return (policyChangePageHeaderML && wizardHeaderTemplate === 'policychange_ml') ? (
            <header className={headerClass}>
                <h1 className={h1Class}>{translator(policyChangePageHeaderML)}</h1>
            </header>
        ) : null;
    }, [policyChangePageHeaderML, translator, wizardHeaderTemplate]);

    return (
        <>
            {submissionQuote}
            {claimHeader()}
            {policyChangeHeader_ML()}
        </>
    );
};

WizardPageHeader.propTypes = {
    wizardSubmission: PropTypes.shape({
        value: PropTypes.shape({}),
        _dtoName: PropTypes.string
    }).isRequired,
    isSideHeader: PropTypes.bool,
    lobFlow: PropTypes.string,
    displayWizardHeader: PropTypes.bool,
    policyChangePageHeaderML: PropTypes.shape({})
};

WizardPageHeader.defaultProps = {
    isSideHeader: false,
    lobFlow: '',
    displayWizardHeader: true
};

export default WizardPageHeader;
